import { Component, EventEmitter, OnDestroy, OnInit, Output, Input, ViewEncapsulation } from '@angular/core';
import { IFiltroVeiculoModel, IVeiculoModel } from '../model/veiculo.model';
import { map, Observable, startWith, debounceTime, distinctUntilChanged, switchMap, of, Subject } from 'rxjs';
import { VeiculoService } from '../veiculo.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { PesquisaVeiculoComponent } from '../pesquisa-veiculo/pesquisa-veiculo.component';

@Component({
  selector: 'app-filtro-veiculo',
  templateUrl: './filtro-veiculo.component.html',
  styleUrls: ['./filtro-veiculo.component.scss'],
  encapsulation: ViewEncapsulation.None,  // <- ESSENCIAL
})
export class FiltroVeiculoComponent implements OnInit, OnDestroy {

  @Output() onVeiculoSelected = new EventEmitter<IVeiculoModel | null>();
  @Input() codigoSubFrota?: number;

  filtro !: IFiltroVeiculoModel;

  filteredOptions!: Observable<any>;

  search$ = new Subject<string>();

  constructor(private veiculoService: VeiculoService, public dialog: MatDialog, private snackBar: SnackBarService) {

    this.filtro = { guid: this.veiculoService.usuario.retorno.guid, coluna: '1', operador: 1 };
  }

  ngOnInit(): void {
    if (this.veiculoService.usuario == null) {
    this.snackBar.flashMessage('Sessão expirada. Favor logar novamente no sistema.', ['snackbar-error'], 'Fechar', 0);
  }
  else {

    this.filteredOptions = this.search$
      .pipe(
        startWith(''),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(val => {
          return this.filter(val || '')
        })
      );

    if (sessionStorage.getItem('filtroVeiculo')) {
      var localFiltro = JSON.parse(sessionStorage.getItem('filtroVeiculo') ?? '{}');
      if (localFiltro.guid === this.filtro.guid) {
        this.filtro = localFiltro;
      } else {
        sessionStorage.removeItem('filtroVeiculo');
      }
    }
  }
  }

  filter(val: string): Observable<any[]> {
    if (!val.length || val.length < 2) {
      return of([]);
    }
    // call the service which makes the http-request
    var filtro: any = { conteudo: val, guid: this.veiculoService.usuario.retorno.guid };
    if (this.codigoSubFrota) {
      filtro.subFrota = { codigo: this.codigoSubFrota };
    }
    if (this.veiculoService.usuario?.retorno?.codigoEntidade) {
      filtro.frota = { codigo: this.veiculoService.usuario.retorno.codigoEntidade };
    }
    return this.veiculoService.searchVeiculo(filtro).pipe(map(response => { return response.retorno }));
  }

  listVeiculo(val: string): Observable<any[]> {
    if (!val.length || val.length < 2) {
      return of([]);
    }
    var filtro: any = { conteudo: val, guid: this.veiculoService.usuario.retorno.guid };
    if (this.codigoSubFrota) {
      filtro.subFrota = { codigo: this.codigoSubFrota };
    }
    return this.veiculoService.searchVeiculo(filtro).pipe(map(response => { return response.retorno }));
  }

  displayFn(veiculo: IVeiculoModel): string {
    return veiculo && veiculo.busca ? veiculo.busca : '';
  }

  onSubmit(): void {
    const dialogRef = this.dialog.open(PesquisaVeiculoComponent, { width: '800px', height: '700px', data: { dataKey: structuredClone(this.filtro) } }).afterClosed()
      .subscribe(response => {
        if (response && response.data) {
          this.filtro.veiculo = response.data;
          this.onVeiculoSelected.emit(this.filtro.veiculo);
        }
      });;
  }

  getPosts(selectVeiculo: IVeiculoModel) {
    this.filtro.veiculo = selectVeiculo;
    this.filtro.parametro = '';
    this.onVeiculoSelected.emit(this.filtro.veiculo);
  }

  limpaFiltro() {
    this.filtro.veiculo = undefined;
    this.onVeiculoSelected.emit(this.filtro.veiculo);
    sessionStorage.removeItem('filtroVeiculo');
    this.filtro = { guid: this.veiculoService.usuario.retorno.guid, coluna: '1', operador: 1 };
  }


  ngOnDestroy() {
    sessionStorage.setItem('filtroVeiculo', JSON.stringify(this.filtro));
  }

}
